export default "__VITE_ASSET__42697879__"